<div class="col-12" *ngIf="isLoading">
  <app-busy [message]="message"></app-busy>
</div>

<div class="container-fluid">
  <form [formGroup]="profileForm"  class="main-form" (ngSubmit)="onSubmit()"> 
    <div style="border-bottom: solid rgb(207, 183, 183) 1px;">
      <h2>Carrier Details</h2>
<div class="row"> 
  <div class="col-md">
    <label for="acc-num"  style="width: 7.8em;margin-left: 15px;">Account number: </label>
    <input id="acc-num"  type="text" class="form" formControlName="accNum"/>
  </div>
  <div class="col-md">
    <label for="last-name" style="width: 7.8em;margin-left: 15px;">Account Name: </label>
    <input id="last-name" type="text" formControlName="accName"/>
  </div>
  </div>
 
  
      <div class="row">
        <div class="col-md">
      <label for="Adress1" style="width: 7.8em;margin-left: 15px;">Address: </label>
      <input id="Adress1" type="text" formControlName="adress1"/></div>
    </div> 
      <div class="row">
        <div class="col-md">
      <label for="Adress2" style="width: 7.8em;margin-left: 15px"></label>
      
      <input id="Adress2" type="text" formControlName="adress2"/></div>
    </div>
       <div class="row">
        <div class="col-md">
         <label for="Adress3" style="width: 7.8em;margin-left: 15px"> </label>
      <input id="Adress3" type="text" formControlName="adress3"/></div>
    </div>
   
   
  </div>
 
    <div style="border-bottom: solid rgb(207, 183, 183) 1px;margin-top: 1.75rem;margin-bottom: 0.75rem;">
      <h2>Permit Details</h2>
    
      <div class="row"> 
        <div class="col-md">
          <label for="permit-num" style="width: 7.8em;margin-left: 15px;">Permit number: </label>
          <input id="permit-num"  type="text" formControlName="permitNum"/>
        </div>
        <div class="col-md">
          <label for="issue-num" style="width: 7.8em;margin-left: 15px;">Issue Number: </label>
          <input id="issue-num" type="text" formControlName="issueNum"/>
        </div>
        </div>

        <div class="row"> 
          <div class="col-md">
            <label for="permitT-num" style="width: 7.8em;margin-left: 15px;">Permit Type: </label>
            <input id="permitT-num"  type="text" formControlName="permitType" class="overflow-auto" style="overflow: auto;"/>
          </div>
          <div class="col-md">
            <label for="faceV-num" style="width: 7.8em;margin-left: 15px;">Face Value Number: </label>
            <input id="faceV-num" type="text" formControlName="faceVNum"/>
          </div>
          </div>

          <div class="row"> 
          <div class="col-md">
            <label for="start-date" style="width: 7.8em;margin-left: 15px;">Start Date: </label>
            <input id="start-date"  type="text" formControlName="startDate"/>
          </div>
          <div class="col-md">
            <label for="ex-date" style="width: 7.8em;margin-left: 15px;">Expiry Date: </label>
            <input id="ex-date" type="text" formControlName="expiryDate"/>
          </div>
          </div>

          <div class="row"> 
            <div class="col-md">
              <label for="dur" style="width: 7.8em;margin-left: 15px;">Duration: </label>
              <input id="dur"  type="text" formControlName="duration"/>
            </div>
            <div class="col-md">
              <label for="stat" style="width: 7.8em;margin-left: 15px;">Status: </label>
              <input id="stat" type="text" formControlName="status"/>
            </div>
            </div>
          
            <div class="row"> 
              <div class="col-md" >
                <!-- <label for="issue-date" style="width: 7.8em;margin-left: 15px;">Issue Date: </label>
                <input id="issue-date"  type="text" formControlName="issueDate"/> -->
              </div>
              <div class="col-md">

              </div>
              </div>
  </div>

  <div style="border-bottom: solid rgb(207, 183, 183) 1px;margin-top: 1.75rem;margin-bottom: 0.75rem;">
    <h2>Vehicle Details</h2>
  
    <div class="row"> 
      <div class="col-md">
        <label for="route" style="width: 7.8em;margin-left: 15px;">Route: </label>
        <input id="route"  type="text" formControlName="route"/>
      </div>
      <div class="col-md">
        <label for="passengers" style="width: 7.8em;margin-left: 15px;">Passengers: </label>
        <input id="passengers" type="text" formControlName="passengers"/>
      </div>
      </div>

      <div class="row"> 
        <div class="col-md">
          <label for="registration" style="width: 7.8em;margin-left: 15px;">Registration : </label>
          <input id="registration"  type="text" formControlName="registration"/>
        </div>
        <div class="col-md">
          <label for="Vin" style="width: 7.8em;margin-left: 15px;">Vin: </label>
          <input id="Vin" type="text" formControlName="vin"/>
        </div>
        </div>
        </div>
        <div style="margin-top: 1rem;">
          <button
          class="btn btn-md m-clr pull-right hd-btn"  style="float: right !important;" (click)="onActive(1)">
          <i class="fa fa-arrow-right" ></i>Continue</button>
        </div>
  </form>
</div>
